import { getGodModeOptionsState } from '@mote/helpers/identity'
import { useGenericRequestHandler } from '../../../handlers'

export const useAccountAddUsersMutation = () => {
  const godModeState = getGodModeOptionsState()
  return useGenericRequestHandler({
    route: 't/addUsers',
    method: 'POST',
    options: {
      json: godModeState.options,
      shouldNotStoreAuthData: godModeState.inGodMode
    }
  })
}
